const prevProjectKey = (competitionId: string) => `juryVotePrevProject:${competitionId}`;

export const setJuryVotePrevProject = (competitionId: string, projectId: string) => {
  if (!competitionId || !projectId) {
    return;
  }
  sessionStorage.setItem(prevProjectKey(competitionId), projectId);
};

export const getJuryVotePrevProject = (competitionId: string): string =>
  (competitionId && sessionStorage.getItem(prevProjectKey(competitionId))) || '';

let lastVoteResetProjectId: string | null = null;

export const resetVoteDataOncePerProject = (projectId: string | undefined, reset: () => void) => {
  if (!projectId || lastVoteResetProjectId === projectId) {
    return;
  }
  lastVoteResetProjectId = projectId;
  reset();
};
const prevProjectKey = (competitionId: string) => `juryVotePrevProject:${competitionId}`;

export const setJuryVotePrevProject = (competitionId: string, projectId: string) => {
  if (!competitionId || !projectId) {
    return;
  }
  sessionStorage.setItem(prevProjectKey(competitionId), projectId);
};

export const getJuryVotePrevProject = (competitionId: string): string =>
  (competitionId && sessionStorage.getItem(prevProjectKey(competitionId))) || '';

let lastVoteResetProjectId: string | null = null;

export const resetVoteDataOncePerProject = (projectId: string | undefined, reset: () => void) => {
  if (!projectId || lastVoteResetProjectId === projectId) {
    return;
  }
  lastVoteResetProjectId = projectId;
  reset();
};
